import ShortCutKey from '../../interaction/shortcutkey/index';
import Refresh from '../../interaction/refresh/index';

function init(): void {
    ShortCutKey.on({
        keyName: 'f5',
        callback: (ev: JQuery.KeyUpEvent): void => {
            Refresh.trigger();
        }
    });
}

export default {
    init
};
